import React from 'react';
import type { ComponentType } from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { Flex, Text, xcss } from '@atlaskit/primitives';
import Button from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import type { GlyphProps } from '@atlaskit/icon';

type HTV2ActionCardProps = {
	title: MessageDescriptor;
	description: MessageDescriptor;
	cta: MessageDescriptor;
	ctaIcon: ComponentType<GlyphProps>;
	link: string;
};

const contentContainerStyles = xcss({
	paddingTop: 'space.250',
	paddingBottom: 'space.200',
	paddingLeft: 'space.200',
	paddingRight: 'space.200',
});

const cardStyles = xcss({
	border: `1px solid ${token('color.border')}`,
	borderRadius: '8px',
	background: token('elevation.surface.overlay'),
	width: '360px',
});

export const HTV2LearningOpportunityCard = ({
	title,
	description,
	cta,
	ctaIcon,
	link,
}: HTV2ActionCardProps) => {
	const handleClick = () => {
		window.open(link, '_blank', 'noreferrer');
	};

	return (
		<Flex direction="column" xcss={cardStyles}>
			<Flex xcss={contentContainerStyles} direction="column" gap="space.100">
				<Heading size="xsmall">
					<FormattedMessage {...title} />
				</Heading>
				<Text>
					<FormattedMessage {...description} />
				</Text>
				<Flex justifyContent="end">
					<Button appearance="subtle" iconBefore={ctaIcon} onClick={handleClick}>
						<FormattedMessage {...cta} />
					</Button>
				</Flex>
			</Flex>
		</Flex>
	);
};
